import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

export const DownloadArrow = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={props.color || theme.palette.grey600}
        fillRule="evenodd"
        clipRule="evenodd"
        d={
          props.variant === "line"
            ? "M12.028 14.666l.07-.006a.66.66 0 00.183-.055l.097-.056.077-.062 2.683-2.682.056-.063a.667.667 0 00-.056-.88l-.063-.055a.667.667 0 00-.88.055l-1.528 1.527V6l-.005-.078A.667.667 0 0011.333 6v6.39l-1.528-1.528-.063-.055a.667.667 0 00-.88.998l2.684 2.683.045.039.087.057.09.041.053.018.123.021.084.002zM17.333 18a.667.667 0 00-.666-.666H7.333l-.077.004a.667.667 0 00.077 1.329h9.334l.077-.005a.667.667 0 00.59-.662z"
            : "M16.2927 11.0407L12 15.3333L7.70671 11.0407C7.07671 10.4107 7.52337 9.33333 8.41404 9.33333H10.6667V5.33333C10.6667 4.59733 11.2634 4 12 4C12.7367 4 13.3334 4.59733 13.3334 5.33333V9.33333H15.586C16.4767 9.33333 16.9227 10.4107 16.2927 11.0407ZM5.33337 18.6667C5.33337 17.9333 5.93337 17.3333 6.66671 17.3333H17.3334C18.0667 17.3333 18.6667 17.9333 18.6667 18.6667C18.6667 19.4 18.0667 20 17.3334 20H6.66671C5.93337 20 5.33337 19.4 5.33337 18.6667Z"
        }
      />
    </svg>
  );
};
